import { CurrentUserModel } from './../../../models/account-ledger.model';
import { AuthService } from './../../../services/auth.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { TenantViewModel, CheckoutViewModel, GetCSPTenant, TenantResponse, CreateCSPOrder, ProgramType, CheckoutStatusModel } from '../../../models/check-out.model';
import { Router, ActivatedRoute } from '@angular/router';
import { CheckOutService } from '../../../services/checkout.service';
// tslint:disable-next-line:import-blacklist
import { Subject, Subscription } from 'rxjs';
import { Validate_CSP_Tenant } from '../../../shared/JavaScript/tenant';
import { ShippingAddressViewModel } from '../../../models/shopping-cart.model';
import { CommonService } from '../../../services/common.service';
import { SubscriptionApiResponse } from '../../../models/api-response.model';
import { MicrosoftCloudAgreementComponent } from '../../../popup-collection/microsoft-cloud-agreement/microsoft-cloud-agreement.component';
import { ManageService } from '../../../services/manage.service';
import { MatDialog } from '@angular/material/dialog';
import { map, switchMap, takeUntil } from 'rxjs/operators';

declare var $: any;
declare var jquery: any;

@Component({
  selector: 'app-tenant',
  templateUrl: './tenant.component.html',
  styleUrls: ['./tenant.component.css']
})
export class TenantComponent implements OnInit, OnDestroy {

  setFullWindow: false;
  title = 'Autopilot Enrolment';
  loadContent = false;
  showTenants = true;
  getCSPTenantView: TenantViewModel;
  shippingAddressViewModel: ShippingAddressViewModel;
  cartId: string;
  cartName: string;
  subscriptionRoute: Subscription;
  checkoutViewModel: CheckoutViewModel;
  subscriptionProgramTypes: string[];
  selectCSPTenantEvent: GetCSPTenant;
  selectADMTenantEvent: GetCSPTenant;
  selectADYTenantEvent: GetCSPTenant;
  selectINTATenantEvent: GetCSPTenant;
  createCSPTenantEvent: CreateCSPOrder;
  createADMTenantEvent: CreateCSPOrder;
  createADYTenantEvent: CreateCSPOrder;
  createINTATenantEvent: CreateCSPOrder;
  createCSPOrder: CreateCSPOrder[] = [];
  selectedMpnId: string;
  selectedProgramType: string;
  tenantView: TenantViewModel;
  mpnList: string[];
  programType: string;
  isCSPValid = true;
  isADYValid = true;
  isADMValid = true;
  isINTAValid = true;
  

  currentUserModel: CurrentUserModel;
  checkoutStatus: CheckoutStatusModel;
  subscriptionResponse: SubscriptionApiResponse;
  ngUnsubscribe: Subject<void> = new Subject<void>();

  serial: string;

  backto: string;

  quoteId: string;

  constructor(private router: Router
    , private activatedRoute: ActivatedRoute
    , private checkOutService: CheckOutService
    , private commonService: CommonService
    , private manageService: ManageService
    , private authService: AuthService
    , private dialog: MatDialog) { }
    

  ngOnInit() {
    
    $('.page-contents').animate({
      scrollLeft: ($('#levelOne').outerWidth() + $('#cart-summary').outerWidth())
    }, 400);
    this.subscriptionRoute = this.activatedRoute.parent.url
      .subscribe(value => {
        this.cartId = value.length > 1 ? value[1].path : '';
        this.cartName = value.length > 1 ? value[2].path : '';
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });

    // this.activatedRoute.parent.parent.paramMap.takeUntil(this.ngUnsubscribe).subscribe((params) => {
    //   this.serial = params.get('serial');
    // })

    this.activatedRoute.parent.parent.parent.paramMap.pipe(
      switchMap((params) => {
        return this.activatedRoute.parent.parent.paramMap.pipe(
          map((param) => {
            return {
              quoteId: params.get('sku'),
              serial: param.get('serial'),
            }
          })
        )
      })
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      this.quoteId = res.quoteId;
      this.serial = res.serial;
      if (this.quoteId) {
        this.backto = 'quote';
      } else if (this.serial) {
        this.backto = 'renewal';
      } else {
        this.backto = 'cart';
      }
    })


    this.checkOutService.passModelWatch.subscribe((res: ShippingAddressViewModel) => {
      this.shippingAddressViewModel = res;

    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });

    this.authService.getLoginInfo().subscribe((model: CurrentUserModel) => {
      this.currentUserModel = model;
    });

    this.checkOutService.currentCheckoutViewModel.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CheckoutViewModel) => {
      this.checkoutViewModel = res;
      if (this.checkoutViewModel.firstStep === 'TENANT') {
        if (this.checkoutViewModel.tenantDetailsRequired === 'NO') {
          this.checkoutStatus = {
            currentStep: 'TENANT',
            firstStep: this.checkoutViewModel.firstStep,
            collectOrder: false,
            hasChosenCheckout: true,
            tenantDetailsRequired: 'NO'
          };
        } else {
          this.checkoutStatus = {
            currentStep: 'TENANT',
            firstStep: this.checkoutViewModel.firstStep,
            collectOrder: false,
            hasChosenCheckout: true,
            tenantDetailsRequired: 'YES'
          };
        }
        this.checkOutService.emitChange(this.checkoutStatus);
      }
      this.programType = this.checkoutViewModel.programType;
      this.subscriptionProgramTypes = this.checkoutViewModel.programType.split(',');
      this.showTenants = res.autoPilotRequired === 'YES' ? false : true;
      this.loadContent = true;
    });

    // this.checkOutService.CartCheckout(toNumber(this.cartId)).subscribe((res: CheckoutViewModel) => {
    //   this.checkoutViewModel = res;
    //   if (this.checkoutViewModel.firstStep === 'TENANT') {
    //     if (this.checkoutViewModel.tenantDetailsRequired === 'NO') {
    //       this.checkoutStatus = {
    //         currentStep: 'TENANT',
    //         firstStep: this.checkoutViewModel.firstStep,
    //         collectOrder: false,
    //         hasChosenCheckout: true,
    //         tenantDetailsRequired: 'NO'
    //       };
    //     } else {
    //       this.checkoutStatus = {
    //         currentStep: 'TENANT',
    //         firstStep: this.checkoutViewModel.firstStep,
    //         collectOrder: false,
    //         hasChosenCheckout: true,
    //         tenantDetailsRequired: 'YES'
    //       };
    //     }
    //     this.checkOutService.emitChange(this.checkoutStatus);
    //   }
    //   this.programType = this.checkoutViewModel.programType;
    //   this.subscriptionProgramTypes = this.checkoutViewModel.programType.split(',');
    //   this.showTenants = res.autoPilotRequired === 'YES' ? false : true;
    // },
    //   (error: any) => {
    //     console.error(error);
    //     this.loadContent = true;
    //   });
  }

  receiveCSPSelectTenant($event): void {
    this.selectCSPTenantEvent = $event;
  }
  receiveADMSelectTenant($event): void {
    this.selectADMTenantEvent = $event;
  }
  receiveADYSelectTenant($event): void {
    this.selectADYTenantEvent = $event;
  }
  receiveINTASelectTenant($event): void {
    this.selectINTATenantEvent = $event;
  }

  receiveSelectMpnId($event): void {
    this.selectedMpnId = $event;
  }

  receiveCSPTenant($event): void {
    this.tenantView = $event;
  }

  ValidateNSaveTenantDetails(): void {
    this.createCSPOrder = [];

    if (this.selectCSPTenantEvent) {
      this.createCSPTenantEvent = {
        in_accountcode: '',
        in_stock_code: '',
        in_qty: '',
        in_parent_stock_code: '',
        in_subscription_desc: '',
        in_tenant_guid: this.selectCSPTenantEvent.out_tenant_id,
        in_mpnid: this.selectedMpnId,
        in_default_email: this.tenantView.defaultOwnerUsageEmail,
        in_login: '',
        type: this.selectCSPTenantEvent.out_tenant_type,
        in_customer_reference: ''
      };
      this.createCSPOrder.push(this.createCSPTenantEvent);
    }
    if (this.selectADYTenantEvent) {
      this.createADYTenantEvent = {
        in_accountcode: '',
        in_stock_code: '',
        in_qty: '',
        in_parent_stock_code: '',
        in_subscription_desc: '',
        in_tenant_guid: this.selectADYTenantEvent.out_tenant_id,
        in_mpnid: this.selectADYTenantEvent.out_related_csn,
        in_default_email: this.selectADYTenantEvent.out_email,
        in_login: '',
        type: this.selectADYTenantEvent.out_tenant_type,
        in_customer_reference: ''
      };
      this.createCSPOrder.push(this.createADYTenantEvent);
    }
    if (this.selectADMTenantEvent) {
      this.createADMTenantEvent = {
        in_accountcode: '',
        in_stock_code: '',
        in_qty: '',
        in_parent_stock_code: '',
        in_subscription_desc: '',
        in_tenant_guid: this.selectADMTenantEvent.out_tenant_id,
        in_mpnid: this.selectADMTenantEvent.out_related_csn,
        in_default_email: this.selectADMTenantEvent.out_email,
        in_login: '',
        type: this.selectADMTenantEvent.out_tenant_type,
        in_customer_reference: ''
      };
      this.createCSPOrder.push(this.createADMTenantEvent);
    }
    if (this.selectINTATenantEvent) {
      this.createINTATenantEvent = {
        in_accountcode: '',
        in_stock_code: '',
        in_qty: '',
        in_parent_stock_code: '',
        in_subscription_desc: '',
        in_tenant_guid: this.selectINTATenantEvent.out_tenant_id,
        in_mpnid: '',
        in_default_email: '',
        in_login: '',
        type: this.selectINTATenantEvent.out_tenant_type,
        in_customer_reference: ''
      };
      this.createCSPOrder.push(this.createINTATenantEvent);
    }
    this.subscriptionProgramTypes.forEach(type => {
      switch (type) {
        case ProgramType[ProgramType.CSP]:
          if (!this.selectCSPTenantEvent) {
            this.isCSPValid = false;
            this.commonService.showError('#tenant_next', 'Please select or create a ' + type + ' tenant', 'right');
          } else {
            this.isCSPValid = Validate_CSP_Tenant(this.selectedProgramType, this.selectedMpnId, this.cartId, this.selectCSPTenantEvent.out_tenant_id, this.tenantView.showDefaultOwnerEmail);
          }
          break;
        case ProgramType[ProgramType.ADM]:
          if (!this.selectADMTenantEvent) {
            this.isADMValid = false;
            this.commonService.showError('#tenant_next', 'Please select or create a ' + type + ' tenant', 'right');
          }
          break;
        case ProgramType[ProgramType.ADY]:
          if (!this.selectADYTenantEvent) {
            this.isADYValid = false;
            this.commonService.showError('#tenant_next', 'Please select or create a ' + type + ' tenant', 'right');
          }
          break;
      }
    });

    if (this.isCSPValid && this.isADMValid && this.isADYValid && this.isINTAValid) {
      this.checkOutService.SetTenantDetail(this.commonService.toNumber(this.cartId), this.createCSPOrder, this.programType).subscribe((res: TenantResponse) => {
        localStorage.setItem('autoPilotTenant', 'YES');
        if (((this.shippingAddressViewModel && this.shippingAddressViewModel.collectTheOrder === true) || this.checkoutViewModel.firstStep === 'ENDUSER' || this.checkoutViewModel.allFreightFreeProducts === 'YES') || (this.checkoutViewModel.containsDirectShippingProducts === 'YES' && this.checkoutViewModel.allFreightFreeProducts === 'YES')) {
          // NZ site is not using donation page
          // if (this.currentUserModel.isAU) {
          //   this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
          // } else {
            this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
          // }
        } else if ((this.shippingAddressViewModel && this.shippingAddressViewModel.collectTheOrder === false) || this.checkoutViewModel.containsDirectShippingProducts === 'NO') {
          this.router.navigate(['freight-ship'], { relativeTo: this.activatedRoute.parent });
        }
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    }
  }

  goPrevious(): void {
    if (this.checkoutViewModel.firstStep !== 'NOENDUSER') {
      this.router.navigate(['end-user'], { relativeTo: this.activatedRoute.parent });
    } else {
      this.router.navigate(['ship-address'], { relativeTo: this.activatedRoute.parent });
    }
  }

  nextPage(): void {
    this.loadContent = false;
    
    if (this.selectCSPTenantEvent || this.selectINTATenantEvent || this.selectADMTenantEvent || this.selectADYTenantEvent) {

      if (this.selectCSPTenantEvent) {

        this.manageService.GetMSCloudAgreementStatus(this.selectCSPTenantEvent.out_tenant_id).subscribe((res: SubscriptionApiResponse) => {
          
          this.subscriptionResponse = res;
          this.loadContent = true;        
          if (this.subscriptionResponse.status === 'Fail') {
            const dialogRef = this.dialog.open(MicrosoftCloudAgreementComponent, {
              width: '630px',
              height: '470px',
              data: {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                status: this.subscriptionResponse.status,
                tenantId: this.selectCSPTenantEvent.out_tenant_id,
                //hdnAgreementVersion: '',
                hdnAgreementVersion:this.subscriptionResponse.agreementMetaData.templateId,
                type: 'CLOSE'
              },
              panelClass: 'mat-dialog-wrapper',
              disableClose: true
            });
            dialogRef.afterClosed().subscribe(result => {
              if (result) {
                this.ValidateNSaveTenantDetails();
              }
            });
          } else {
            this.ValidateNSaveTenantDetails();
          }        
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
      } else {
        this.ValidateNSaveTenantDetails();
      }
    } else {
      this.loadContent = true;
      this.commonService.showError('#tenant_next', 'Please select or create a tenant', 'right');
    }
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  skipToNextStep() {

    this.checkOutService.RemoveCartEndUser(this.commonService.toNumber(this.cartId)).subscribe((response: any) => {
      if (((this.shippingAddressViewModel && this.shippingAddressViewModel.collectTheOrder === true) || this.checkoutViewModel.firstStep === 'ENDUSER' || this.checkoutViewModel.allFreightFreeProducts === 'YES') || (this.checkoutViewModel.containsDirectShippingProducts === 'YES' && this.checkoutViewModel.allFreightFreeProducts === 'YES')) {
        // NZ site is not using donation page
        // if (this.currentUserModel.isAU) {
        //   this.router.navigate(['donation'], { relativeTo: this.activatedRoute.parent });
        // } else {
          this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
        // }
      } else if ((this.shippingAddressViewModel && this.shippingAddressViewModel.collectTheOrder === false) || this.checkoutViewModel.containsDirectShippingProducts === 'NO') {
        this.router.navigate(['freight-ship'], { relativeTo: this.activatedRoute.parent });
      }
      localStorage.setItem('autoPilotTenant', 'NO');

      this.checkoutStatus = {
        currentStep: 'ADDRESS',
        firstStep: this.checkoutViewModel.firstStep,
        collectOrder: this.shippingAddressViewModel.collectTheOrder,
        hasChosenCheckout: true,
        tenantDetailsRequired: 'NO'
      };
      this.checkOutService.emitChange(this.checkoutStatus);
    },
      (error: any) => {
        console.error(error);
      });

  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  backtoCart() {
    this.checkOutService.monitorShowCartSummary('show');
    this.router.navigateByUrl(`/myCarts/cart/${this.cartId}/${this.cartName}`);
  }

  backtoRenewals() {
    this.router.navigate(['.'],{relativeTo:this.activatedRoute.parent.parent});
    // this.router.navigateByUrl(`manageRenewalsNew/renewalDetails/${this.serial}`);
  }

  backtoQuotes() {
    this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent.parent });
    $('.combination-loader').animate(
      { scrollLeft: (250 + $('#price-list-detail').width()) }, 100)

  }
  close() {
    // this.checkoutStatus = {
    //   currentStep: '',
    //   firstStep: '',
    //   hasChosenCheckout: false,
    //   collectOrder: false,
    //   tenantDetailsRequired: ''
    // };
    // this.checkOutService.emitChange(this.checkoutStatus);
    // this.router.navigateByUrl(`/myCarts/cart/${this.cartId}/${this.cartName}`);
    this.router.navigate(['../'], { relativeTo: this.activatedRoute });

  }
}
